export function compare2Dates(date1, date2) {
	if (date1.getTime() > date2.getTime()) {
		return 1;
	}
	if (date1.getTime() < date2.getTime()) {
		return -1;
	}
	return 0;
}
